export { NumberInfoComponent } from './number-info.component';
export { AdNumberInfoModule } from './number-info.module';
